import router from '@/router'

import { useAccount } from '@/stores/account'
import { useAuth } from '@/stores/auth'

let lastRefresh = 0

function logout() {
  const account = useAccount()
  account.logout()
  return router.replace('/login')
}

export function errorInterceptor(error) {
  if (error.response && (error.response.status === 401 || error.response.data?.code === 'token_not_valid')) {
    const auth = useAuth()

    if (auth.refresh) {
      const newRefreshDate = Date.now()

      // Only one refresh each 60 seconds
      if (newRefreshDate - lastRefresh > 60000) {
        const account = useAccount()
        lastRefresh = newRefreshDate

        return account
          .refresh(auth.refresh)
          .then(() => {
            router.go()
          })
          .catch(logout)
      } else {
        return logout()
      }
    } else {
      return logout()
    }
  }

  // Format the error to reject
  const data = error.response?.data?.data || null
  const errors = error.response?.data?.meta?.errors || []

  return Promise.reject({
    ...error,
    data,
    errors,
  })
}
